document.querySelectorAll('.cw-problems-slider,.cw-pdp-maya-reviews-swiper').forEach(slider => {
  const track = slider.querySelector('.swiper-wrapper');
  if (!track) return;
  const root = slider.parentElement;
  const reviews = slider.classList.contains('cw-pdp-maya-reviews-swiper');
  const previous = root.querySelector(reviews ? '.cw-pdp-maya-reviews-prev' : '.cw-problems-button-prev');
  const next = root.querySelector(reviews ? '.cw-pdp-maya-reviews-next' : '.cw-problems-button-next');
  const pagination = root.querySelector(reviews ? '.cw-swiper-pagination' : '.cw-problems-pagination');
  let slides = Array.from(track.children).filter(el => el.classList.contains('swiper-slide'));
  if (reviews) {
    slides.sort((a, b) => Number(a.dataset.swiperSlideIndex) - Number(b.dataset.swiperSlideIndex));
    slides.forEach(slide => track.append(slide));
  }
  let step = 0;
  let maxIndex = 0;
  const label = pagination?.querySelector('[aria-label]')?.getAttribute('aria-label') || '';
  function activate(control, action) {
    control?.addEventListener('click', action);
    control?.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        action();
      }
    });
  }
  function move(index) {
    const destination = reviews ? (index < 0 ? maxIndex : index > maxIndex ? 0 : index) : Math.max(0, Math.min(index, maxIndex));
    track.scrollTo({left: destination * step, behavior: 'smooth'});
  }
  function sync() {
    const index = Math.round(track.scrollLeft / step);
    [[previous, index <= 0], [next, index >= maxIndex]].forEach(([control, disabled]) => {
      if (!control) return;
      const off = !reviews && disabled;
      control.setAttribute('aria-disabled', String(off));
      control.tabIndex = off ? -1 : 0;
      control.classList.toggle('swiper-button-disabled', off);
    });
    pagination?.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, i) => {
      bullet.classList.toggle('swiper-pagination-bullet-active', i === index);
      bullet.setAttribute('aria-current', String(i === index));
    });
  }
  let previousWidth = -1, previousViewport = -1;
  function resize() {
    const currentWidth = slider.clientWidth;
    if (currentWidth === previousWidth && innerWidth === previousViewport) return;
    previousWidth = currentWidth; previousViewport = innerWidth;
    const count = reviews ? (innerWidth >= 1024 ? 4.6 : innerWidth >= 768 ? 3 : 1) : (innerWidth >= 1024 ? 3.3 : innerWidth >= 768 ? 3.2 : 1.3);
    const gap = !reviews && innerWidth < 768 ? 16 : 20;
    const width = (currentWidth - gap * (count - 1)) / count;
    step = width + gap;
    maxIndex = Math.ceil(slides.length - count);
    slider.style.setProperty('--ref-slide-width', width + 'px');
    slider.style.setProperty('--ref-slide-gap', gap + 'px');
    if (pagination) {
      pagination.replaceChildren();
      for (let i = 0; i <= maxIndex; i++) {
        const bullet = document.createElement('span');
        bullet.className = 'swiper-pagination-bullet';
        bullet.tabIndex = 0;
        bullet.setAttribute('role', 'button');
        bullet.setAttribute('aria-label', label.replace(/\d+/, String(i + 1)));
        activate(bullet, () => move(i));
        pagination.append(bullet);
      }
    }
    sync();
  }
  activate(previous, () => move(Math.round(track.scrollLeft / step) - 1));
  activate(next, () => move(Math.round(track.scrollLeft / step) + 1));
  let scheduled = false;
  track.addEventListener('scroll', () => { if (scheduled) return; scheduled = true; requestAnimationFrame(() => { scheduled = false; sync(); }); }, {passive: true});
  new ResizeObserver(resize).observe(slider);
  resize();
});
